import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QueryInvoicesPageComponent } from 'src/pages/query-invoices-page/query-invoices-page.component';
import { StatusMonitorPageComponent } from 'src/pages/status-monitor-page/status-monitor-page.component';
import { LoginPageComponent } from 'src/pages/login-page/login-page.component';
import { AppNav } from 'src/routes/app-nav';
import { RoleGuard } from 'src/guards/role.guard';
import { AuthGuard } from '@/guards/auth.guard';
import { RequestAccessPageComponent } from '@/pages/access-management/request-access-page/request-access-page.component';
import { AccessRequestsPageComponent } from '@/pages/access-management/access-requests-page/access-requests-page.component';
import { ApprovalPageComponent } from '@/pages/access-management/approval-page/approval-page.component';
import { ManageEngagementsPageComponent } from '@/pages/access-management/manage-engagements-page/manage-engagements-page.component';
import { AccessDeniedPageComponent } from './pages/access-denied/access-denied-page.component';
import { TransactionQueryPageComponent } from 'src/pages/transaction-query-page/transaction-query-page.component';
import { TransactionQueryStatusPageComponent } from 'src/pages/transaction-query-status-page/transaction-query-status-page.component';
import { TransactionQueryDetailsPageComponent } from 'src/pages/transaction-query-details-page/transaction-query-details-page.component';

const routes: Routes = [
  {
    path: AppNav.Login.route,
    component: LoginPageComponent,
    data: { bodyClass: 'page_login' },
  },
  {
    path: AppNav.Home.route,
    pathMatch: 'full',
    redirectTo: '/' + AppNav.QueryInvoices.route,
  },
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: AppNav.QueryInvoices.route,
        component: QueryInvoicesPageComponent,
        data: { bodyClass: 'page-query-invoices' },
      },
      {
        path: AppNav.TransactionQuery.route,
        component: TransactionQueryPageComponent,
        data: { bodyClass: 'page-transaction-query' },
      },
      {
        path: AppNav.StatusMonitor.route,
        children: [
          {
            path: '',
            redirectTo: AppNav.QueryInvoicesStatus.route,
            pathMatch: 'full',
          },
          {
            path: AppNav.QueryInvoicesStatus.route,
            component: StatusMonitorPageComponent,
            data: { bodyClass: 'page-query-invoices-status' },
          },
          {
            path: AppNav.TransactionQueryStatus.route,
            component: TransactionQueryStatusPageComponent,
            data: { bodyClass: 'page-transaction-query-status' },
          },
          {
            path: AppNav.TransactionQueryStatus.route + '/:id',
            component: TransactionQueryDetailsPageComponent,
            data: { bodyClass: 'page-transaction-query-details' },
          },
        ],
      },
      {
        path: AppNav.AccessDenied.route,
        component: AccessDeniedPageComponent,
      },
      {
        path: AppNav.AccessManagement.route,
        children: [
          {
            path: AppNav.RequestAccess.route,
            component: RequestAccessPageComponent,
            data: { bodyClass: 'page-request-access' },
          },
          {
            path: AppNav.AccessRequests.route,
            component: AccessRequestsPageComponent,
            data: { bodyClass: 'page-manage-requests' },
          },
          {
            path: AppNav.ManageEngagements.route,
            component: ManageEngagementsPageComponent,
            data: { bodyClass: 'page-manage-engagement' },
          },
          {
            path: AppNav.Approval.route,
            component: ApprovalPageComponent,
            data: { bodyClass: 'page-approval' },
          },
        ],
      },
      {
        path: AppNav.Admin.route,
        canActivate: [RoleGuard],
        data: {
          expectedRole: 'Admin',
        },
        loadChildren: () =>
          import('src/modules/admin.module').then((m) => m.AdminModule),
      },
      {
        path: AppNav.QueryUI.route,
        loadChildren: () =>
          import('src/pages/query-ui/query-ui.module').then(
            (m) => m.QueryUiModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
